module.exports = "button {\n    margin-top: 2px;\n    margin-bottom: 2px;\n}\n\n.right {\n    text-align: right;\n}\n\n.filter {\n    text-align: right;\n    margin-bottom: 10px;\n}\n\ntr {\n    font-size: 0.8em;\n}\n\ntd {\n    font-size: 0.8em;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/offers/offers.component.css
// module id = ./src/app/offers/offers.component.css
// module chunks = main